import '@/utils/date'
import { DateFormat, ds, ts } from '@/plugins/i18nFormat'

export function dateRange(from: string | Date, to: string | Date | null): string {
    from = new Date(from)
    to = to !== null ? new Date(to) : null

    return ds(from, (to != null && !from.isSameAs(to)) ? DateFormat.EventFrom : DateFormat.EventTo)
        + ((to == null || from.isSameAs(to)) ? '' : ' ' + ts('till') + ' ' + ds(to, DateFormat.EventTo))
}
